import { useDispatch } from "react-redux";
import { encounters } from "./encounters";
import { setEncounters } from "../../../../entities/patient-stats/encounters/encounters.slice";

export const useGetEncounters = () => {
  const dispatch = useDispatch();

  const getEncountersByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = encounters.filter(
          (e) => String(e.patientId) === patientId,
        );
        resolve(filtered[0] ?? encounters[0]);
      }, 400);
    }); // имитация API

    dispatch(setEncounters(res)); // сохраняем в сторе
  };

  return {
    getEncountersByPatientId,
  };
};
